'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Space = require('../../Space/src/Space.js');
var Dialog_module = require('../styles/Dialog.module.less.js');
var DialogContext = require('./DialogContext.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description The Dialog component is used to show content on top of an overlay that requires user interaction
 *
 * @component
 * @example
 * ```jsx
 * <Header title="Title">content</Dialog>
 * ```
 */
const Header = React__namespace.forwardRef((props, ref) => {
    const { title, subtitle, icon, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Dialog_module.default);
    const { fullscreen } = React__namespace.useContext(DialogContext.default);
    const classNames = cx(className, 'header', {
        fullscreen,
    });
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(Space.Space, { ref: ref, size: 16, align: "center", className: classNames, ...restProps },
            icon && React__namespace.createElement("div", { className: cx('icon') }, icon),
            title || subtitle ? (React__namespace.createElement(Space.Space, { direction: "vertical", size: 8, className: cx('title-wrapper') },
                title && React__namespace.createElement("div", { className: cx('title') }, title),
                subtitle && React__namespace.createElement("div", { className: cx('subtitle') }, subtitle))) : null),
        children));
});
Header.defaultProps = {};
Header.displayName = 'Header';

exports.Header = Header;
//# sourceMappingURL=Header.js.map
